import { Upload, Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import React from 'react';
const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
const UploadImg = ({ fileList, setFileList }) => {
	const [previewImage, setPreviewImage] = useState('');
	const [previewOpen, setPreviewOpen] = useState(false);
	const handlePreview = async (file) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}
		setPreviewImage(file.url || file.preview);
		setPreviewOpen(true);
	};
	const props = {
		accept: ".png, .jpg, .jpeg,webp",
		limit: 1,
		onChange(info) {
			setFileList(info.fileList)
		},
		customRequest(options) {
			const { onSuccess, file } = options;
			onSuccess('上传成功', file);
		},
		onPreview: handlePreview,
	};
	const uploadButton = (
		<button
			style={{ border: "none", background: 'none' }} type="button">
			<PlusOutlined />
			<div style={{ marginTop: 8 }} > 上传 </div>
		</button>
	);

	return <div>
		<Upload
			listType="picture-card"
			fileList={fileList}
			{...props}
		>
			{fileList.length >= 1 ? null : uploadButton}
		</Upload>
		{previewImage && (
			<Image
				wrapperStyle={{
					display: 'none',
				}}
				preview={{
					visible: previewOpen,
					onVisibleChange: (visible) => setPreviewOpen(visible),
					afterOpenChange: (visible) => !visible && setPreviewImage(''),
				}}
				src={previewImage}
			/>
		)}
	</div>
}
export default UploadImg;